module.exports = __webpack_public_path__ + "static/media/icn-menu.f29d2edb.svg";